const CUT_REG_EXP = /(\s[А-Яа-яA-Za-z]|[.\s,]){1,2}$/;

export const cutText = (text, maxLength = 150) => {
  if (text.length <= maxLength) return text;

  return `${text
    .slice(0, maxLength - 3)
    // replace last 2-3 symbols and replace them with 3 dot
    .replace(CUT_REG_EXP, '')}...`;
};
